/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 * Magento API
 * <a href='/'>API Documentation</a>
 * OpenAPI spec version: 2.0.0
 */
import {useMutation, useQuery, useSuspenseQuery} from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type {
    Ab933fde28f66638635ab2cfe8253d83200,
    Ab933fde28f66638635ab2cfe8253d83400,
    Ab933fde28f66638635ab2cfe8253d83Body,
    AddToCartItemResponse,
    AjaxErrorResponse,
    ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGet200,
    ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
    ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody,
    CartData,
    CartItemV2,
    CreatePrimerSession201,
    DeleteQuoteV2Params,
    ErrorResponse,
    Faa3a9534cda0df3b9ceba80ba53ed90Params,
    Gen2d3bcbcb0cb8035d70b21dee2720b35c200,
    Gen4a47db7b7e8f6adc386ff58009fbb463200,
    Gen4ac31ca0545e2d5fb0c7e513216ec562200,
    Gen6e855d67d62a192bac687712fbe3e8c6200,
    Gen6e855d67d62a192bac687712fbe3e8c6422,
    Gen6e855d67d62a192bac687712fbe3e8c6500,
    Gen6e855d67d62a192bac687712fbe3e8c6Body,
    Gen8dd386969caf00deb3afaf792f3d7796422,
    Gen8dd386969caf00deb3afaf792f3d7796500,
    Gen8dd386969caf00deb3afaf792f3d7796Body,
    Gen942f711176de9f4331ff9dac2db02c7b422,
    Gen942f711176de9f4331ff9dac2db02c7b500,
    Gen942f711176de9f4331ff9dac2db02c7bBody,
    Gen9c4b0234e3ac7e2e0dd24db110b4adfb200,
    Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams,
    GetAllowedShippingMethodsParams,
    GetCartCountV2200,
    GetQuoteItemV2Params,
    GetQuoteItemsV2CartItemsParams,
    GetQuoteItemsV2CartParams,
    GetQuoteTotalsV2Params,
    PostQuoteItemByTokenV2Body,
    PostQuoteItemV2201,
    PostQuoteItemV2Body,
    PostQuoteV2protectionBody,
    PrevalidateOrder201,
    PrevalidateOrderBody,
    PutQuoteItem200,
    PutQuoteItemV2200,
    PutQuoteShippingBody,
    PutQuoteShippingV2Body,
    QuoteItemV2,
    QuoteTotal,
    RestCartData,
    RestMiniCartData,
    SaveOrder201,
    SaveOrderBody,
    ShippingMethodList,
    SpecialOffers,
    UpdateCart,
    UpdateCartV2Body,
} from '../magentoAPI.schemas';
import {fetcherMagento} from '../../axios-instance';

/**
 * Use session data.
 * @deprecated
 * @summary Get quote data
 */
export const faa3a9534cda0df3b9ceba80ba53ed90 = (
    params?: Faa3a9534cda0df3b9ceba80ba53ed90Params,
    signal?: AbortSignal,
) => {
    return fetcherMagento<CartData>({
        url: `/optimaxcart/react/getQuote`,
        method: 'GET',
        params,
        signal,
    });
};

export const getFaa3a9534cda0df3b9ceba80ba53ed90QueryKey = (
    params?: Faa3a9534cda0df3b9ceba80ba53ed90Params,
) => {
    return [`/optimaxcart/react/getQuote`, ...(params ? [params] : [])] as const;
};

export const getFaa3a9534cda0df3b9ceba80ba53ed90QueryOptions = <
    TData = Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
    TError = void,
>(
    params?: Faa3a9534cda0df3b9ceba80ba53ed90Params,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getFaa3a9534cda0df3b9ceba80ba53ed90QueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>> = ({
        signal,
    }) => faa3a9534cda0df3b9ceba80ba53ed90(params, signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Faa3a9534cda0df3b9ceba80ba53ed90QueryResult = NonNullable<
    Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>
>;
export type Faa3a9534cda0df3b9ceba80ba53ed90QueryError = void;

/**
 * @deprecated
 * @summary Get quote data
 */
export const useFaa3a9534cda0df3b9ceba80ba53ed90 = <
    TData = Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
    TError = void,
>(
    params?: Faa3a9534cda0df3b9ceba80ba53ed90Params,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
                TError,
                TData
            >
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getFaa3a9534cda0df3b9ceba80ba53ed90QueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getFaa3a9534cda0df3b9ceba80ba53ed90SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
    TError = void,
>(
    params?: Faa3a9534cda0df3b9ceba80ba53ed90Params,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getFaa3a9534cda0df3b9ceba80ba53ed90QueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>> = ({
        signal,
    }) => faa3a9534cda0df3b9ceba80ba53ed90(params, signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Faa3a9534cda0df3b9ceba80ba53ed90SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>
>;
export type Faa3a9534cda0df3b9ceba80ba53ed90SuspenseQueryError = void;

/**
 * @deprecated
 * @summary Get quote data
 */
export const useFaa3a9534cda0df3b9ceba80ba53ed90Suspense = <
    TData = Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
    TError = void,
>(
    params?: Faa3a9534cda0df3b9ceba80ba53ed90Params,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof faa3a9534cda0df3b9ceba80ba53ed90>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getFaa3a9534cda0df3b9ceba80ba53ed90SuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * Move quote item from one quote to other
 * @deprecated
 * @summary Move quote item from one quote to other
 */
export const gen4a47db7b7e8f6adc386ff58009fbb463 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    moveTo: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
) => {
    return fetcherMagento<Gen4a47db7b7e8f6adc386ff58009fbb463200>({
        url: `/optimaxcart/react/moveItem/quoteType/${quoteType}/id/${id}/moveTo/${moveTo}`,
        method: 'PUT',
    });
};

export const getGen4a47db7b7e8f6adc386ff58009fbb463MutationOptions = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen4a47db7b7e8f6adc386ff58009fbb463>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            moveTo: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof gen4a47db7b7e8f6adc386ff58009fbb463>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        id: number;
        moveTo: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
    },
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof gen4a47db7b7e8f6adc386ff58009fbb463>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            moveTo: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        }
    > = props => {
        const {quoteType, id, moveTo} = props ?? {};

        return gen4a47db7b7e8f6adc386ff58009fbb463(quoteType, id, moveTo);
    };

    return {mutationFn, ...mutationOptions};
};

export type Gen4a47db7b7e8f6adc386ff58009fbb463MutationResult = NonNullable<
    Awaited<ReturnType<typeof gen4a47db7b7e8f6adc386ff58009fbb463>>
>;

export type Gen4a47db7b7e8f6adc386ff58009fbb463MutationError = void;

/**
 * @deprecated
 * @summary Move quote item from one quote to other
 */
export const useGen4a47db7b7e8f6adc386ff58009fbb463 = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen4a47db7b7e8f6adc386ff58009fbb463>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            moveTo: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof gen4a47db7b7e8f6adc386ff58009fbb463>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        id: number;
        moveTo: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
    },
    TContext
> => {
    const mutationOptions = getGen4a47db7b7e8f6adc386ff58009fbb463MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary add option to optimax cart
 */
export const gen942f711176de9f4331ff9dac2db02c7b = (
    gen942f711176de9f4331ff9dac2db02c7bBody: Gen942f711176de9f4331ff9dac2db02c7bBody,
) => {
    return fetcherMagento<CartData>({
        url: `/optimaxcart/react/addOption`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: gen942f711176de9f4331ff9dac2db02c7bBody,
    });
};

export const getGen942f711176de9f4331ff9dac2db02c7bMutationOptions = <
    TError = Gen942f711176de9f4331ff9dac2db02c7b422 | Gen942f711176de9f4331ff9dac2db02c7b500,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen942f711176de9f4331ff9dac2db02c7b>>,
        TError,
        {data: Gen942f711176de9f4331ff9dac2db02c7bBody},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof gen942f711176de9f4331ff9dac2db02c7b>>,
    TError,
    {data: Gen942f711176de9f4331ff9dac2db02c7bBody},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof gen942f711176de9f4331ff9dac2db02c7b>>,
        {data: Gen942f711176de9f4331ff9dac2db02c7bBody}
    > = props => {
        const {data} = props ?? {};

        return gen942f711176de9f4331ff9dac2db02c7b(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type Gen942f711176de9f4331ff9dac2db02c7bMutationResult = NonNullable<
    Awaited<ReturnType<typeof gen942f711176de9f4331ff9dac2db02c7b>>
>;
export type Gen942f711176de9f4331ff9dac2db02c7bMutationBody =
    Gen942f711176de9f4331ff9dac2db02c7bBody;
export type Gen942f711176de9f4331ff9dac2db02c7bMutationError =
    | Gen942f711176de9f4331ff9dac2db02c7b422
    | Gen942f711176de9f4331ff9dac2db02c7b500;

/**
 * @summary add option to optimax cart
 */
export const useGen942f711176de9f4331ff9dac2db02c7b = <
    TError = Gen942f711176de9f4331ff9dac2db02c7b422 | Gen942f711176de9f4331ff9dac2db02c7b500,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen942f711176de9f4331ff9dac2db02c7b>>,
        TError,
        {data: Gen942f711176de9f4331ff9dac2db02c7bBody},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof gen942f711176de9f4331ff9dac2db02c7b>>,
    TError,
    {data: Gen942f711176de9f4331ff9dac2db02c7bBody},
    TContext
> => {
    const mutationOptions = getGen942f711176de9f4331ff9dac2db02c7bMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary remove option from optimax cart
 */
export const gen8dd386969caf00deb3afaf792f3d7796 = (
    gen8dd386969caf00deb3afaf792f3d7796Body: Gen8dd386969caf00deb3afaf792f3d7796Body,
) => {
    return fetcherMagento<CartData>({
        url: `/optimaxcart/react/removeOption`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: gen8dd386969caf00deb3afaf792f3d7796Body,
    });
};

export const getGen8dd386969caf00deb3afaf792f3d7796MutationOptions = <
    TError = Gen8dd386969caf00deb3afaf792f3d7796422 | Gen8dd386969caf00deb3afaf792f3d7796500,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen8dd386969caf00deb3afaf792f3d7796>>,
        TError,
        {data: Gen8dd386969caf00deb3afaf792f3d7796Body},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof gen8dd386969caf00deb3afaf792f3d7796>>,
    TError,
    {data: Gen8dd386969caf00deb3afaf792f3d7796Body},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof gen8dd386969caf00deb3afaf792f3d7796>>,
        {data: Gen8dd386969caf00deb3afaf792f3d7796Body}
    > = props => {
        const {data} = props ?? {};

        return gen8dd386969caf00deb3afaf792f3d7796(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type Gen8dd386969caf00deb3afaf792f3d7796MutationResult = NonNullable<
    Awaited<ReturnType<typeof gen8dd386969caf00deb3afaf792f3d7796>>
>;
export type Gen8dd386969caf00deb3afaf792f3d7796MutationBody =
    Gen8dd386969caf00deb3afaf792f3d7796Body;
export type Gen8dd386969caf00deb3afaf792f3d7796MutationError =
    | Gen8dd386969caf00deb3afaf792f3d7796422
    | Gen8dd386969caf00deb3afaf792f3d7796500;

/**
 * @summary remove option from optimax cart
 */
export const useGen8dd386969caf00deb3afaf792f3d7796 = <
    TError = Gen8dd386969caf00deb3afaf792f3d7796422 | Gen8dd386969caf00deb3afaf792f3d7796500,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen8dd386969caf00deb3afaf792f3d7796>>,
        TError,
        {data: Gen8dd386969caf00deb3afaf792f3d7796Body},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof gen8dd386969caf00deb3afaf792f3d7796>>,
    TError,
    {data: Gen8dd386969caf00deb3afaf792f3d7796Body},
    TContext
> => {
    const mutationOptions = getGen8dd386969caf00deb3afaf792f3d7796MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * This endpoint allows users to add a product to the optimax cart.
 * @summary Add a product to the optimax cart
 */
export const gen6e855d67d62a192bac687712fbe3e8c6 = (
    gen6e855d67d62a192bac687712fbe3e8c6Body: Gen6e855d67d62a192bac687712fbe3e8c6Body,
) => {
    return fetcherMagento<Gen6e855d67d62a192bac687712fbe3e8c6200>({
        url: `/optimaxcart/upsell/addToCart`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: gen6e855d67d62a192bac687712fbe3e8c6Body,
    });
};

export const getGen6e855d67d62a192bac687712fbe3e8c6MutationOptions = <
    TError = Gen6e855d67d62a192bac687712fbe3e8c6422 | Gen6e855d67d62a192bac687712fbe3e8c6500,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen6e855d67d62a192bac687712fbe3e8c6>>,
        TError,
        {data: Gen6e855d67d62a192bac687712fbe3e8c6Body},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof gen6e855d67d62a192bac687712fbe3e8c6>>,
    TError,
    {data: Gen6e855d67d62a192bac687712fbe3e8c6Body},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof gen6e855d67d62a192bac687712fbe3e8c6>>,
        {data: Gen6e855d67d62a192bac687712fbe3e8c6Body}
    > = props => {
        const {data} = props ?? {};

        return gen6e855d67d62a192bac687712fbe3e8c6(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type Gen6e855d67d62a192bac687712fbe3e8c6MutationResult = NonNullable<
    Awaited<ReturnType<typeof gen6e855d67d62a192bac687712fbe3e8c6>>
>;
export type Gen6e855d67d62a192bac687712fbe3e8c6MutationBody =
    Gen6e855d67d62a192bac687712fbe3e8c6Body;
export type Gen6e855d67d62a192bac687712fbe3e8c6MutationError =
    | Gen6e855d67d62a192bac687712fbe3e8c6422
    | Gen6e855d67d62a192bac687712fbe3e8c6500;

/**
 * @summary Add a product to the optimax cart
 */
export const useGen6e855d67d62a192bac687712fbe3e8c6 = <
    TError = Gen6e855d67d62a192bac687712fbe3e8c6422 | Gen6e855d67d62a192bac687712fbe3e8c6500,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen6e855d67d62a192bac687712fbe3e8c6>>,
        TError,
        {data: Gen6e855d67d62a192bac687712fbe3e8c6Body},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof gen6e855d67d62a192bac687712fbe3e8c6>>,
    TError,
    {data: Gen6e855d67d62a192bac687712fbe3e8c6Body},
    TContext
> => {
    const mutationOptions = getGen6e855d67d62a192bac687712fbe3e8c6MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @deprecated
 * @summary Update Quote Item
 */
export const putQuoteItem = (id: number, updateCart: UpdateCart) => {
    return fetcherMagento<PutQuoteItem200>({
        url: `/api/rest/optimaxcheckout/cart/item/${id}`,
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        data: updateCart,
    });
};

export const getPutQuoteItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteItem>>,
        TError,
        {id: number; data: UpdateCart},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putQuoteItem>>,
    TError,
    {id: number; data: UpdateCart},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putQuoteItem>>,
        {id: number; data: UpdateCart}
    > = props => {
        const {id, data} = props ?? {};

        return putQuoteItem(id, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PutQuoteItemMutationResult = NonNullable<Awaited<ReturnType<typeof putQuoteItem>>>;
export type PutQuoteItemMutationBody = UpdateCart;
export type PutQuoteItemMutationError = unknown;

/**
 * @deprecated
 * @summary Update Quote Item
 */
export const usePutQuoteItem = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteItem>>,
        TError,
        {id: number; data: UpdateCart},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof putQuoteItem>>,
    TError,
    {id: number; data: UpdateCart},
    TContext
> => {
    const mutationOptions = getPutQuoteItemMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @deprecated
 * @summary Delete Quote Item
 */
export const deleteQuoteItem = (id: number) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/cart/item/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteQuoteItemMutationOptions = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteQuoteItem>>,
        TError,
        {id: number},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuoteItem>>,
    TError,
    {id: number},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteQuoteItem>>,
        {id: number}
    > = props => {
        const {id} = props ?? {};

        return deleteQuoteItem(id);
    };

    return {mutationFn, ...mutationOptions};
};

export type DeleteQuoteItemMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteQuoteItem>>
>;

export type DeleteQuoteItemMutationError = unknown;

/**
 * @deprecated
 * @summary Delete Quote Item
 */
export const useDeleteQuoteItem = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteQuoteItem>>,
        TError,
        {id: number},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteQuoteItem>>,
    TError,
    {id: number},
    TContext
> => {
    const mutationOptions = getDeleteQuoteItemMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get media file of uploaded prescription
 */
export const getPrescriptionFileByCart = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    signal?: AbortSignal,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}/prescriptionfile`,
        method: 'GET',
        signal,
    });
};

export const getGetPrescriptionFileByCartQueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
) => {
    return [`/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}/prescriptionfile`] as const;
};

export const getGetPrescriptionFileByCartQueryOptions = <
    TData = Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getPrescriptionFileByCart>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPrescriptionFileByCartQueryKey(quoteType, id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrescriptionFileByCart>>> = ({
        signal,
    }) => getPrescriptionFileByCart(quoteType, id, signal);

    return {queryKey, queryFn, enabled: !!(quoteType && id), ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetPrescriptionFileByCartQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPrescriptionFileByCart>>
>;
export type GetPrescriptionFileByCartQueryError = ErrorResponse;

/**
 * @summary Get media file of uploaded prescription
 */
export const useGetPrescriptionFileByCart = <
    TData = Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getPrescriptionFileByCart>>, TError, TData>
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetPrescriptionFileByCartQueryOptions(quoteType, id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetPrescriptionFileByCartSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetPrescriptionFileByCartQueryKey(quoteType, id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrescriptionFileByCart>>> = ({
        signal,
    }) => getPrescriptionFileByCart(quoteType, id, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!(quoteType && id),
        ...queryOptions,
    } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetPrescriptionFileByCartSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getPrescriptionFileByCart>>
>;
export type GetPrescriptionFileByCartSuspenseQueryError = ErrorResponse;

/**
 * @summary Get media file of uploaded prescription
 */
export const useGetPrescriptionFileByCartSuspense = <
    TData = Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getPrescriptionFileByCart>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetPrescriptionFileByCartSuspenseQueryOptions(quoteType, id, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get Quote Items
 */
export const getQuoteItemsV2Cart = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartParams,
    signal?: AbortSignal,
) => {
    return fetcherMagento<RestCartData>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetQuoteItemsV2CartQueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartParams,
) => {
    return [`/api/rest/optimaxcheckout/v2/${quoteType}/cart`, ...(params ? [params] : [])] as const;
};

export const getGetQuoteItemsV2CartQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2Cart>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteItemsV2CartQueryKey(quoteType, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>> = ({signal}) =>
        getQuoteItemsV2Cart(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemsV2Cart>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemsV2CartQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemsV2Cart>>
>;
export type GetQuoteItemsV2CartQueryError = unknown;

/**
 * @summary Get Quote Items
 */
export const useGetQuoteItemsV2Cart = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2Cart>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>, TError, TData>
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemsV2CartQueryOptions(quoteType, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteItemsV2CartSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2Cart>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteItemsV2CartQueryKey(quoteType, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>> = ({signal}) =>
        getQuoteItemsV2Cart(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemsV2Cart>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemsV2CartSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemsV2Cart>>
>;
export type GetQuoteItemsV2CartSuspenseQueryError = unknown;

/**
 * @summary Get Quote Items
 */
export const useGetQuoteItemsV2CartSuspense = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2Cart>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2Cart>>, TError, TData>
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemsV2CartSuspenseQueryOptions(quoteType, params, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Update Cart
 */
export const updateCartV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    updateCartV2Body: UpdateCartV2Body,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart`,
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        data: updateCartV2Body,
    });
};

export const getUpdateCartV2MutationOptions = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateCartV2>>,
        TError,
        {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: UpdateCartV2Body},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof updateCartV2>>,
    TError,
    {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: UpdateCartV2Body},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof updateCartV2>>,
        {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: UpdateCartV2Body}
    > = props => {
        const {quoteType, data} = props ?? {};

        return updateCartV2(quoteType, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type UpdateCartV2MutationResult = NonNullable<Awaited<ReturnType<typeof updateCartV2>>>;
export type UpdateCartV2MutationBody = UpdateCartV2Body;
export type UpdateCartV2MutationError = unknown;

/**
 * @summary Update Cart
 */
export const useUpdateCartV2 = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof updateCartV2>>,
        TError,
        {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: UpdateCartV2Body},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof updateCartV2>>,
    TError,
    {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: UpdateCartV2Body},
    TContext
> => {
    const mutationOptions = getUpdateCartV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get address from quote
 */
export const apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
    signal?: AbortSignal,
) => {
    return fetcherMagento<ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGet200>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/address`,
        method: 'GET',
        params,
        signal,
    });
};

export const getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
) => {
    return [
        `/api/rest/optimaxcheckout/v2/${quoteType}/cart/address`,
        ...(params ? [params] : []),
    ] as const;
};

export const getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryOptions = <
    TData = Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryKey(quoteType, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>
    > = ({signal}) => apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>
>;
export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryError = unknown;

/**
 * @summary Get address from quote
 */
export const useApiRestOptimaxcheckoutV2QuoteTypeCartAddressGet = <
    TData = Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
                TError,
                TData
            >
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryOptions(
        quoteType,
        params,
        options,
    );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetQueryKey(quoteType, params);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>
    > = ({signal}) => apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>
>;
export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetSuspenseQueryError = unknown;

/**
 * @summary Get address from quote
 */
export const useApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetSuspense = <
    TData = Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressGet>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getApiRestOptimaxcheckoutV2QuoteTypeCartAddressGetSuspenseQueryOptions(
        quoteType,
        params,
        options,
    );

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Update quote addresses
 */
export const apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    apiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/address`,
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        data: apiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody,
    });
};

export const getApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutMutationOptions = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        data: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody;
    },
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody;
        }
    > = props => {
        const {quoteType, data} = props ?? {};

        return apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut(quoteType, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutMutationResult = NonNullable<
    Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut>>
>;
export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutMutationBody =
    ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody;
export type ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutMutationError = void;

/**
 * @summary Update quote addresses
 */
export const useApiRestOptimaxcheckoutV2QuoteTypeCartAddressPut = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof apiRestOptimaxcheckoutV2QuoteTypeCartAddressPut>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        data: ApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutBody;
    },
    TContext
> => {
    const mutationOptions =
        getApiRestOptimaxcheckoutV2QuoteTypeCartAddressPutMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get address from quote
 */
export const gen2d3bcbcb0cb8035d70b21dee2720b35c = (token: string, signal?: AbortSignal) => {
    return fetcherMagento<Gen2d3bcbcb0cb8035d70b21dee2720b35c200>({
        url: `/api/rest/optimaxcheckout/v2/cart/address/${token}`,
        method: 'GET',
        signal,
    });
};

export const getGen2d3bcbcb0cb8035d70b21dee2720b35cQueryKey = (token: string) => {
    return [`/api/rest/optimaxcheckout/v2/cart/address/${token}`] as const;
};

export const getGen2d3bcbcb0cb8035d70b21dee2720b35cQueryOptions = <
    TData = Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
    TError = unknown,
>(
    token: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGen2d3bcbcb0cb8035d70b21dee2720b35cQueryKey(token);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>
    > = ({signal}) => gen2d3bcbcb0cb8035d70b21dee2720b35c(token, signal);

    return {queryKey, queryFn, enabled: !!token, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Gen2d3bcbcb0cb8035d70b21dee2720b35cQueryResult = NonNullable<
    Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>
>;
export type Gen2d3bcbcb0cb8035d70b21dee2720b35cQueryError = unknown;

/**
 * @summary Get address from quote
 */
export const useGen2d3bcbcb0cb8035d70b21dee2720b35c = <
    TData = Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
    TError = unknown,
>(
    token: string,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
                TError,
                TData
            >
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGen2d3bcbcb0cb8035d70b21dee2720b35cQueryOptions(token, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGen2d3bcbcb0cb8035d70b21dee2720b35cSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
    TError = unknown,
>(
    token: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGen2d3bcbcb0cb8035d70b21dee2720b35cQueryKey(token);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>
    > = ({signal}) => gen2d3bcbcb0cb8035d70b21dee2720b35c(token, signal);

    return {queryKey, queryFn, enabled: !!token, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Gen2d3bcbcb0cb8035d70b21dee2720b35cSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>
>;
export type Gen2d3bcbcb0cb8035d70b21dee2720b35cSuspenseQueryError = unknown;

/**
 * @summary Get address from quote
 */
export const useGen2d3bcbcb0cb8035d70b21dee2720b35cSuspense = <
    TData = Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
    TError = unknown,
>(
    token: string,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof gen2d3bcbcb0cb8035d70b21dee2720b35c>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGen2d3bcbcb0cb8035d70b21dee2720b35cSuspenseQueryOptions(token, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get quote special offers
 */
export const getQuoteSpecialOffers = (signal?: AbortSignal) => {
    return fetcherMagento<SpecialOffers[]>({
        url: `/api/rest/optimaxcheckout/v2/cart/specialoffers`,
        method: 'GET',
        signal,
    });
};

export const getGetQuoteSpecialOffersQueryKey = () => {
    return [`/api/rest/optimaxcheckout/v2/cart/specialoffers`] as const;
};

export const getGetQuoteSpecialOffersQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteSpecialOffers>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getQuoteSpecialOffers>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteSpecialOffersQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteSpecialOffers>>> = ({signal}) =>
        getQuoteSpecialOffers(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteSpecialOffers>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteSpecialOffersQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteSpecialOffers>>
>;
export type GetQuoteSpecialOffersQueryError = ErrorResponse;

/**
 * @summary Get quote special offers
 */
export const useGetQuoteSpecialOffers = <
    TData = Awaited<ReturnType<typeof getQuoteSpecialOffers>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getQuoteSpecialOffers>>, TError, TData>
    >;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteSpecialOffersQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteSpecialOffersSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteSpecialOffers>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteSpecialOffers>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteSpecialOffersQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteSpecialOffers>>> = ({signal}) =>
        getQuoteSpecialOffers(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuoteSpecialOffers>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteSpecialOffersSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteSpecialOffers>>
>;
export type GetQuoteSpecialOffersSuspenseQueryError = ErrorResponse;

/**
 * @summary Get quote special offers
 */
export const useGetQuoteSpecialOffersSuspense = <
    TData = Awaited<ReturnType<typeof getQuoteSpecialOffers>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteSpecialOffers>>, TError, TData>
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteSpecialOffersSuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get Cart Count
 */
export const getCartCountV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    signal?: AbortSignal,
) => {
    return fetcherMagento<GetCartCountV2200>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/count`,
        method: 'GET',
        signal,
    });
};

export const getGetCartCountV2QueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
) => {
    return [`/api/rest/optimaxcheckout/v2/${quoteType}/cart/count`] as const;
};

export const getGetCartCountV2QueryOptions = <
    TData = Awaited<ReturnType<typeof getCartCountV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartCountV2>>, TError, TData>>;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCartCountV2QueryKey(quoteType);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCartCountV2>>> = ({signal}) =>
        getCartCountV2(quoteType, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getCartCountV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetCartCountV2QueryResult = NonNullable<Awaited<ReturnType<typeof getCartCountV2>>>;
export type GetCartCountV2QueryError = unknown;

/**
 * @summary Get Cart Count
 */
export const useGetCartCountV2 = <
    TData = Awaited<ReturnType<typeof getCartCountV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCartCountV2>>, TError, TData>>;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetCartCountV2QueryOptions(quoteType, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetCartCountV2SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getCartCountV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCartCountV2>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetCartCountV2QueryKey(quoteType);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCartCountV2>>> = ({signal}) =>
        getCartCountV2(quoteType, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getCartCountV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetCartCountV2SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getCartCountV2>>
>;
export type GetCartCountV2SuspenseQueryError = unknown;

/**
 * @summary Get Cart Count
 */
export const useGetCartCountV2Suspense = <
    TData = Awaited<ReturnType<typeof getCartCountV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCartCountV2>>, TError, TData>
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetCartCountV2SuspenseQueryOptions(quoteType, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @deprecated
 * @summary Count cart
 */
export const gen4ac31ca0545e2d5fb0c7e513216ec562 = (signal?: AbortSignal) => {
    return fetcherMagento<Gen4ac31ca0545e2d5fb0c7e513216ec562200>({
        url: `/api/rest/checkout/cart/count`,
        method: 'GET',
        signal,
    });
};

export const getGen4ac31ca0545e2d5fb0c7e513216ec562QueryKey = () => {
    return [`/api/rest/checkout/cart/count`] as const;
};

export const getGen4ac31ca0545e2d5fb0c7e513216ec562QueryOptions = <
    TData = Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
            TError,
            TData
        >
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGen4ac31ca0545e2d5fb0c7e513216ec562QueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>
    > = ({signal}) => gen4ac31ca0545e2d5fb0c7e513216ec562(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Gen4ac31ca0545e2d5fb0c7e513216ec562QueryResult = NonNullable<
    Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>
>;
export type Gen4ac31ca0545e2d5fb0c7e513216ec562QueryError = unknown;

/**
 * @deprecated
 * @summary Count cart
 */
export const useGen4ac31ca0545e2d5fb0c7e513216ec562 = <
    TData = Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<
            Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
            TError,
            TData
        >
    >;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGen4ac31ca0545e2d5fb0c7e513216ec562QueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGen4ac31ca0545e2d5fb0c7e513216ec562SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
            TError,
            TData
        >
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGen4ac31ca0545e2d5fb0c7e513216ec562QueryKey();

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>
    > = ({signal}) => gen4ac31ca0545e2d5fb0c7e513216ec562(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Gen4ac31ca0545e2d5fb0c7e513216ec562SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>
>;
export type Gen4ac31ca0545e2d5fb0c7e513216ec562SuspenseQueryError = unknown;

/**
 * @deprecated
 * @summary Count cart
 */
export const useGen4ac31ca0545e2d5fb0c7e513216ec562Suspense = <
    TData = Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof gen4ac31ca0545e2d5fb0c7e513216ec562>>,
            TError,
            TData
        >
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGen4ac31ca0545e2d5fb0c7e513216ec562SuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Create Quote Item By Token
 */
export const postQuoteItemByTokenV2 = (postQuoteItemByTokenV2Body: PostQuoteItemByTokenV2Body) => {
    return fetcherMagento<AddToCartItemResponse>({
        url: `/api/rest/optimaxcheckout/v2/cart/direct`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: postQuoteItemByTokenV2Body,
    });
};

export const getPostQuoteItemByTokenV2MutationOptions = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postQuoteItemByTokenV2>>,
        TError,
        {data: PostQuoteItemByTokenV2Body},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postQuoteItemByTokenV2>>,
    TError,
    {data: PostQuoteItemByTokenV2Body},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postQuoteItemByTokenV2>>,
        {data: PostQuoteItemByTokenV2Body}
    > = props => {
        const {data} = props ?? {};

        return postQuoteItemByTokenV2(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PostQuoteItemByTokenV2MutationResult = NonNullable<
    Awaited<ReturnType<typeof postQuoteItemByTokenV2>>
>;
export type PostQuoteItemByTokenV2MutationBody = PostQuoteItemByTokenV2Body;
export type PostQuoteItemByTokenV2MutationError = void;

/**
 * @summary Create Quote Item By Token
 */
export const usePostQuoteItemByTokenV2 = <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postQuoteItemByTokenV2>>,
        TError,
        {data: PostQuoteItemByTokenV2Body},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof postQuoteItemByTokenV2>>,
    TError,
    {data: PostQuoteItemByTokenV2Body},
    TContext
> => {
    const mutationOptions = getPostQuoteItemByTokenV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get Quote Item
 */
export const getQuoteItemV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params?: GetQuoteItemV2Params,
    signal?: AbortSignal,
) => {
    return fetcherMagento<QuoteItemV2>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetQuoteItemV2QueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params?: GetQuoteItemV2Params,
) => {
    return [
        `/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetQuoteItemV2QueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params?: GetQuoteItemV2Params,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemV2>>, TError, TData>>;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteItemV2QueryKey(quoteType, id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemV2>>> = ({signal}) =>
        getQuoteItemV2(quoteType, id, params, signal);

    return {queryKey, queryFn, enabled: !!(quoteType && id), ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemV2QueryResult = NonNullable<Awaited<ReturnType<typeof getQuoteItemV2>>>;
export type GetQuoteItemV2QueryError = unknown;

/**
 * @summary Get Quote Item
 */
export const useGetQuoteItemV2 = <
    TData = Awaited<ReturnType<typeof getQuoteItemV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params?: GetQuoteItemV2Params,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemV2>>, TError, TData>>;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemV2QueryOptions(quoteType, id, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteItemV2SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params?: GetQuoteItemV2Params,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemV2>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteItemV2QueryKey(quoteType, id, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemV2>>> = ({signal}) =>
        getQuoteItemV2(quoteType, id, params, signal);

    return {
        queryKey,
        queryFn,
        enabled: !!(quoteType && id),
        ...queryOptions,
    } as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemV2>>, TError, TData> & {
        queryKey: QueryKey;
    };
};

export type GetQuoteItemV2SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemV2>>
>;
export type GetQuoteItemV2SuspenseQueryError = unknown;

/**
 * @summary Get Quote Item
 */
export const useGetQuoteItemV2Suspense = <
    TData = Awaited<ReturnType<typeof getQuoteItemV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params?: GetQuoteItemV2Params,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemV2>>, TError, TData>
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemV2SuspenseQueryOptions(quoteType, id, params, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * Endpoint used session data.
 * @summary Update Quote Item
 */
export const putQuoteItemV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    cartItemV2: CartItemV2,
) => {
    return fetcherMagento<PutQuoteItemV2200>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}`,
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        data: cartItemV2,
    });
};

export const getPutQuoteItemV2MutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteItemV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            data: CartItemV2;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putQuoteItemV2>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        id: number;
        data: CartItemV2;
    },
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putQuoteItemV2>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            data: CartItemV2;
        }
    > = props => {
        const {quoteType, id, data} = props ?? {};

        return putQuoteItemV2(quoteType, id, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PutQuoteItemV2MutationResult = NonNullable<Awaited<ReturnType<typeof putQuoteItemV2>>>;
export type PutQuoteItemV2MutationBody = CartItemV2;
export type PutQuoteItemV2MutationError = ErrorResponse;

/**
 * @summary Update Quote Item
 */
export const usePutQuoteItemV2 = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteItemV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            data: CartItemV2;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof putQuoteItemV2>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        id: number;
        data: CartItemV2;
    },
    TContext
> => {
    const mutationOptions = getPutQuoteItemV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete Quote Item
 */
export const deleteQuoteItemV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}`,
        method: 'DELETE',
    });
};

export const getDeleteQuoteItemV2MutationOptions = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteQuoteItemV2>>,
        TError,
        {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; id: number},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuoteItemV2>>,
    TError,
    {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; id: number},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteQuoteItemV2>>,
        {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; id: number}
    > = props => {
        const {quoteType, id} = props ?? {};

        return deleteQuoteItemV2(quoteType, id);
    };

    return {mutationFn, ...mutationOptions};
};

export type DeleteQuoteItemV2MutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteQuoteItemV2>>
>;

export type DeleteQuoteItemV2MutationError = unknown;

/**
 * @summary Delete Quote Item
 */
export const useDeleteQuoteItemV2 = <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteQuoteItemV2>>,
        TError,
        {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; id: number},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteQuoteItemV2>>,
    TError,
    {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; id: number},
    TContext
> => {
    const mutationOptions = getDeleteQuoteItemV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get Quote Items
 */
export const getQuoteItemsV2CartItems = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartItemsParams,
    signal?: AbortSignal,
) => {
    return fetcherMagento<QuoteItemV2[]>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/items`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetQuoteItemsV2CartItemsQueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartItemsParams,
) => {
    return [
        `/api/rest/optimaxcheckout/v2/${quoteType}/cart/items`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetQuoteItemsV2CartItemsQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartItemsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetQuoteItemsV2CartItemsQueryKey(quoteType, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>> = ({
        signal,
    }) => getQuoteItemsV2CartItems(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemsV2CartItemsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>
>;
export type GetQuoteItemsV2CartItemsQueryError = unknown;

/**
 * @summary Get Quote Items
 */
export const useGetQuoteItemsV2CartItems = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartItemsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>, TError, TData>
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemsV2CartItemsQueryOptions(quoteType, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteItemsV2CartItemsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartItemsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetQuoteItemsV2CartItemsQueryKey(quoteType, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>> = ({
        signal,
    }) => getQuoteItemsV2CartItems(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemsV2CartItemsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>
>;
export type GetQuoteItemsV2CartItemsSuspenseQueryError = unknown;

/**
 * @summary Get Quote Items
 */
export const useGetQuoteItemsV2CartItemsSuspense = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteItemsV2CartItemsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getQuoteItemsV2CartItems>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemsV2CartItemsSuspenseQueryOptions(
        quoteType,
        params,
        options,
    );

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Create Quote Item
 */
export const postQuoteItemV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    postQuoteItemV2Body: PostQuoteItemV2Body,
) => {
    return fetcherMagento<PostQuoteItemV2201>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/items`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: postQuoteItemV2Body,
    });
};

export const getPostQuoteItemV2MutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postQuoteItemV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: PostQuoteItemV2Body;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postQuoteItemV2>>,
    TError,
    {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: PostQuoteItemV2Body},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postQuoteItemV2>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: PostQuoteItemV2Body;
        }
    > = props => {
        const {quoteType, data} = props ?? {};

        return postQuoteItemV2(quoteType, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PostQuoteItemV2MutationResult = NonNullable<
    Awaited<ReturnType<typeof postQuoteItemV2>>
>;
export type PostQuoteItemV2MutationBody = PostQuoteItemV2Body;
export type PostQuoteItemV2MutationError = ErrorResponse;

/**
 * @summary Create Quote Item
 */
export const usePostQuoteItemV2 = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postQuoteItemV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: PostQuoteItemV2Body;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof postQuoteItemV2>>,
    TError,
    {quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist'; data: PostQuoteItemV2Body},
    TContext
> => {
    const mutationOptions = getPostQuoteItemV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Delete all Quote Items
 */
export const deleteQuoteV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: DeleteQuoteV2Params,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/items`,
        method: 'DELETE',
        params,
    });
};

export const getDeleteQuoteV2MutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteQuoteV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            params?: DeleteQuoteV2Params;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuoteV2>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        params?: DeleteQuoteV2Params;
    },
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteQuoteV2>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            params?: DeleteQuoteV2Params;
        }
    > = props => {
        const {quoteType, params} = props ?? {};

        return deleteQuoteV2(quoteType, params);
    };

    return {mutationFn, ...mutationOptions};
};

export type DeleteQuoteV2MutationResult = NonNullable<Awaited<ReturnType<typeof deleteQuoteV2>>>;

export type DeleteQuoteV2MutationError = ErrorResponse;

/**
 * @summary Delete all Quote Items
 */
export const useDeleteQuoteV2 = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteQuoteV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            params?: DeleteQuoteV2Params;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof deleteQuoteV2>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        params?: DeleteQuoteV2Params;
    },
    TContext
> => {
    const mutationOptions = getDeleteQuoteV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Move quote item from one quote to other
 * @summary Move quote item from one quote to other
 */
export const gen9c4b0234e3ac7e2e0dd24db110b4adfb = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    id: number,
    params: Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams,
) => {
    return fetcherMagento<Gen9c4b0234e3ac7e2e0dd24db110b4adfb200>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/item/${id}/move`,
        method: 'PUT',
        params,
    });
};

export const getGen9c4b0234e3ac7e2e0dd24db110b4adfbMutationOptions = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen9c4b0234e3ac7e2e0dd24db110b4adfb>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            params: Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof gen9c4b0234e3ac7e2e0dd24db110b4adfb>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        id: number;
        params: Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams;
    },
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof gen9c4b0234e3ac7e2e0dd24db110b4adfb>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            params: Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams;
        }
    > = props => {
        const {quoteType, id, params} = props ?? {};

        return gen9c4b0234e3ac7e2e0dd24db110b4adfb(quoteType, id, params);
    };

    return {mutationFn, ...mutationOptions};
};

export type Gen9c4b0234e3ac7e2e0dd24db110b4adfbMutationResult = NonNullable<
    Awaited<ReturnType<typeof gen9c4b0234e3ac7e2e0dd24db110b4adfb>>
>;

export type Gen9c4b0234e3ac7e2e0dd24db110b4adfbMutationError = void;

/**
 * @summary Move quote item from one quote to other
 */
export const useGen9c4b0234e3ac7e2e0dd24db110b4adfb = <
    TError = void,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen9c4b0234e3ac7e2e0dd24db110b4adfb>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            id: number;
            params: Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof gen9c4b0234e3ac7e2e0dd24db110b4adfb>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        id: number;
        params: Gen9c4b0234e3ac7e2e0dd24db110b4adfbParams;
    },
    TContext
> => {
    const mutationOptions = getGen9c4b0234e3ac7e2e0dd24db110b4adfbMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Load quote by token
 */
export const ab933fde28f66638635ab2cfe8253d83 = (
    ab933fde28f66638635ab2cfe8253d83Body: Ab933fde28f66638635ab2cfe8253d83Body,
) => {
    return fetcherMagento<Ab933fde28f66638635ab2cfe8253d83200>({
        url: `/api/rest/optimaxcheckout/v2/cart/loadQuote`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: ab933fde28f66638635ab2cfe8253d83Body,
    });
};

export const getAb933fde28f66638635ab2cfe8253d83MutationOptions = <
    TError = Ab933fde28f66638635ab2cfe8253d83400,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof ab933fde28f66638635ab2cfe8253d83>>,
        TError,
        {data: Ab933fde28f66638635ab2cfe8253d83Body},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof ab933fde28f66638635ab2cfe8253d83>>,
    TError,
    {data: Ab933fde28f66638635ab2cfe8253d83Body},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof ab933fde28f66638635ab2cfe8253d83>>,
        {data: Ab933fde28f66638635ab2cfe8253d83Body}
    > = props => {
        const {data} = props ?? {};

        return ab933fde28f66638635ab2cfe8253d83(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type Ab933fde28f66638635ab2cfe8253d83MutationResult = NonNullable<
    Awaited<ReturnType<typeof ab933fde28f66638635ab2cfe8253d83>>
>;
export type Ab933fde28f66638635ab2cfe8253d83MutationBody = Ab933fde28f66638635ab2cfe8253d83Body;
export type Ab933fde28f66638635ab2cfe8253d83MutationError = Ab933fde28f66638635ab2cfe8253d83400;

/**
 * @summary Load quote by token
 */
export const useAb933fde28f66638635ab2cfe8253d83 = <
    TError = Ab933fde28f66638635ab2cfe8253d83400,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof ab933fde28f66638635ab2cfe8253d83>>,
        TError,
        {data: Ab933fde28f66638635ab2cfe8253d83Body},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof ab933fde28f66638635ab2cfe8253d83>>,
    TError,
    {data: Ab933fde28f66638635ab2cfe8253d83Body},
    TContext
> => {
    const mutationOptions = getAb933fde28f66638635ab2cfe8253d83MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get Available Quote Shipping Methods
 */
export const getQuoteShippingsV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    signal?: AbortSignal,
) => {
    return fetcherMagento<ShippingMethodList>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/shippings`,
        method: 'GET',
        signal,
    });
};

export const getGetQuoteShippingsV2QueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
) => {
    return [`/api/rest/optimaxcheckout/v2/${quoteType}/cart/shippings`] as const;
};

export const getGetQuoteShippingsV2QueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteShippingsV2>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteShippingsV2>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteShippingsV2QueryKey(quoteType);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteShippingsV2>>> = ({signal}) =>
        getQuoteShippingsV2(quoteType, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteShippingsV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteShippingsV2QueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteShippingsV2>>
>;
export type GetQuoteShippingsV2QueryError = ErrorResponse;

/**
 * @summary Get Available Quote Shipping Methods
 */
export const useGetQuoteShippingsV2 = <
    TData = Awaited<ReturnType<typeof getQuoteShippingsV2>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteShippingsV2>>, TError, TData>
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteShippingsV2QueryOptions(quoteType, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteShippingsV2SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteShippingsV2>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteShippingsV2>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteShippingsV2QueryKey(quoteType);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteShippingsV2>>> = ({signal}) =>
        getQuoteShippingsV2(quoteType, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuoteShippingsV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteShippingsV2SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteShippingsV2>>
>;
export type GetQuoteShippingsV2SuspenseQueryError = ErrorResponse;

/**
 * @summary Get Available Quote Shipping Methods
 */
export const useGetQuoteShippingsV2Suspense = <
    TData = Awaited<ReturnType<typeof getQuoteShippingsV2>>,
    TError = ErrorResponse,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteShippingsV2>>, TError, TData>
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteShippingsV2SuspenseQueryOptions(quoteType, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Set Quote Shipping Method
 */
export const putQuoteShippingV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    putQuoteShippingV2Body: PutQuoteShippingV2Body,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/shipping`,
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        data: putQuoteShippingV2Body,
    });
};

export const getPutQuoteShippingV2MutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteShippingV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: PutQuoteShippingV2Body;
        },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putQuoteShippingV2>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        data: PutQuoteShippingV2Body;
    },
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putQuoteShippingV2>>,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: PutQuoteShippingV2Body;
        }
    > = props => {
        const {quoteType, data} = props ?? {};

        return putQuoteShippingV2(quoteType, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PutQuoteShippingV2MutationResult = NonNullable<
    Awaited<ReturnType<typeof putQuoteShippingV2>>
>;
export type PutQuoteShippingV2MutationBody = PutQuoteShippingV2Body;
export type PutQuoteShippingV2MutationError = ErrorResponse;

/**
 * @summary Set Quote Shipping Method
 */
export const usePutQuoteShippingV2 = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteShippingV2>>,
        TError,
        {
            quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
            data: PutQuoteShippingV2Body;
        },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof putQuoteShippingV2>>,
    TError,
    {
        quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist';
        data: PutQuoteShippingV2Body;
    },
    TContext
> => {
    const mutationOptions = getPutQuoteShippingV2MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get Quote Totals
 */
export const getQuoteTotalsV2 = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteTotalsV2Params,
    signal?: AbortSignal,
) => {
    return fetcherMagento<QuoteTotal>({
        url: `/api/rest/optimaxcheckout/v2/${quoteType}/cart/totals`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetQuoteTotalsV2QueryKey = (
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteTotalsV2Params,
) => {
    return [
        `/api/rest/optimaxcheckout/v2/${quoteType}/cart/totals`,
        ...(params ? [params] : []),
    ] as const;
};

export const getGetQuoteTotalsV2QueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteTotalsV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteTotalsV2Params,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteTotalsV2>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteTotalsV2QueryKey(quoteType, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteTotalsV2>>> = ({signal}) =>
        getQuoteTotalsV2(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteTotalsV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteTotalsV2QueryResult = NonNullable<Awaited<ReturnType<typeof getQuoteTotalsV2>>>;
export type GetQuoteTotalsV2QueryError = unknown;

/**
 * @summary Get Quote Totals
 */
export const useGetQuoteTotalsV2 = <
    TData = Awaited<ReturnType<typeof getQuoteTotalsV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteTotalsV2Params,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getQuoteTotalsV2>>, TError, TData>
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteTotalsV2QueryOptions(quoteType, params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteTotalsV2SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteTotalsV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteTotalsV2Params,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteTotalsV2>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteTotalsV2QueryKey(quoteType, params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteTotalsV2>>> = ({signal}) =>
        getQuoteTotalsV2(quoteType, params, signal);

    return {queryKey, queryFn, enabled: !!quoteType, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuoteTotalsV2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteTotalsV2SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteTotalsV2>>
>;
export type GetQuoteTotalsV2SuspenseQueryError = unknown;

/**
 * @summary Get Quote Totals
 */
export const useGetQuoteTotalsV2Suspense = <
    TData = Awaited<ReturnType<typeof getQuoteTotalsV2>>,
    TError = unknown,
>(
    quoteType: 'regular' | 'retail' | 'delivery' | 'hto' | 'wishlist',
    params?: GetQuoteTotalsV2Params,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteTotalsV2>>, TError, TData>
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteTotalsV2SuspenseQueryOptions(quoteType, params, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Get Quote Items
 */
export const getQuoteItemsV2MiniCart = (signal?: AbortSignal) => {
    return fetcherMagento<RestMiniCartData>({
        url: `/api/rest/optimaxcheckout/v2/minicart`,
        method: 'GET',
        signal,
    });
};

export const getGetQuoteItemsV2MiniCartQueryKey = () => {
    return [`/api/rest/optimaxcheckout/v2/minicart`] as const;
};

export const getGetQuoteItemsV2MiniCartQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteItemsV2MiniCartQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>> = ({
        signal,
    }) => getQuoteItemsV2MiniCart(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemsV2MiniCartQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>
>;
export type GetQuoteItemsV2MiniCartQueryError = unknown;

/**
 * @summary Get Quote Items
 */
export const useGetQuoteItemsV2MiniCart = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>, TError, TData>
    >;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemsV2MiniCartQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetQuoteItemsV2MiniCartSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetQuoteItemsV2MiniCartQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>> = ({
        signal,
    }) => getQuoteItemsV2MiniCart(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetQuoteItemsV2MiniCartSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>
>;
export type GetQuoteItemsV2MiniCartSuspenseQueryError = unknown;

/**
 * @summary Get Quote Items
 */
export const useGetQuoteItemsV2MiniCartSuspense = <
    TData = Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof getQuoteItemsV2MiniCart>>, TError, TData>
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetQuoteItemsV2MiniCartSuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Prevalidate order
 */
export const prevalidateOrder = (prevalidateOrderBody: PrevalidateOrderBody) => {
    return fetcherMagento<PrevalidateOrder201>({
        url: `/api/rest/optimaxcheckout/v2/prevalidate`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: prevalidateOrderBody,
    });
};

export const getPrevalidateOrderMutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof prevalidateOrder>>,
        TError,
        {data: PrevalidateOrderBody},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof prevalidateOrder>>,
    TError,
    {data: PrevalidateOrderBody},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof prevalidateOrder>>,
        {data: PrevalidateOrderBody}
    > = props => {
        const {data} = props ?? {};

        return prevalidateOrder(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PrevalidateOrderMutationResult = NonNullable<
    Awaited<ReturnType<typeof prevalidateOrder>>
>;
export type PrevalidateOrderMutationBody = PrevalidateOrderBody;
export type PrevalidateOrderMutationError = ErrorResponse;

/**
 * @summary Prevalidate order
 */
export const usePrevalidateOrder = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof prevalidateOrder>>,
        TError,
        {data: PrevalidateOrderBody},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof prevalidateOrder>>,
    TError,
    {data: PrevalidateOrderBody},
    TContext
> => {
    const mutationOptions = getPrevalidateOrderMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Create Primer session
 */
export const createPrimerSession = (createPrimerSessionBody?: unknown) => {
    return fetcherMagento<CreatePrimerSession201>({
        url: `/api/rest/optimaxcheckout/v2/primer/session`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: createPrimerSessionBody,
    });
};

export const getCreatePrimerSessionMutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createPrimerSession>>,
        TError,
        {data: unknown},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof createPrimerSession>>,
    TError,
    {data: unknown},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof createPrimerSession>>,
        {data: unknown}
    > = props => {
        const {data} = props ?? {};

        return createPrimerSession(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type CreatePrimerSessionMutationResult = NonNullable<
    Awaited<ReturnType<typeof createPrimerSession>>
>;
export type CreatePrimerSessionMutationBody = unknown;
export type CreatePrimerSessionMutationError = ErrorResponse;

/**
 * @summary Create Primer session
 */
export const useCreatePrimerSession = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof createPrimerSession>>,
        TError,
        {data: unknown},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof createPrimerSession>>,
    TError,
    {data: unknown},
    TContext
> => {
    const mutationOptions = getCreatePrimerSessionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Post Quote Protection
 */
export const postQuoteV2protection = (postQuoteV2protectionBody: PostQuoteV2protectionBody) => {
    return fetcherMagento<void>({
        url: `/api/rest/optimaxcheckout/v2/protection`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: postQuoteV2protectionBody,
    });
};

export const getPostQuoteV2protectionMutationOptions = <
    TError = ErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postQuoteV2protection>>,
        TError,
        {data: PostQuoteV2protectionBody},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postQuoteV2protection>>,
    TError,
    {data: PostQuoteV2protectionBody},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postQuoteV2protection>>,
        {data: PostQuoteV2protectionBody}
    > = props => {
        const {data} = props ?? {};

        return postQuoteV2protection(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PostQuoteV2protectionMutationResult = NonNullable<
    Awaited<ReturnType<typeof postQuoteV2protection>>
>;
export type PostQuoteV2protectionMutationBody = PostQuoteV2protectionBody;
export type PostQuoteV2protectionMutationError = ErrorResponse;

/**
 * @summary Post Quote Protection
 */
export const usePostQuoteV2protection = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postQuoteV2protection>>,
        TError,
        {data: PostQuoteV2protectionBody},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof postQuoteV2protection>>,
    TError,
    {data: PostQuoteV2protectionBody},
    TContext
> => {
    const mutationOptions = getPostQuoteV2protectionMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Save order
 */
export const saveOrder = (saveOrderBody: SaveOrderBody) => {
    return fetcherMagento<SaveOrder201>({
        url: `/api/rest/optimaxcheckout/v2/saveorder`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: saveOrderBody,
    });
};

export const getSaveOrderMutationOptions = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof saveOrder>>,
        TError,
        {data: SaveOrderBody},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof saveOrder>>,
    TError,
    {data: SaveOrderBody},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof saveOrder>>,
        {data: SaveOrderBody}
    > = props => {
        const {data} = props ?? {};

        return saveOrder(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type SaveOrderMutationResult = NonNullable<Awaited<ReturnType<typeof saveOrder>>>;
export type SaveOrderMutationBody = SaveOrderBody;
export type SaveOrderMutationError = ErrorResponse;

/**
 * @summary Save order
 */
export const useSaveOrder = <TError = ErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof saveOrder>>,
        TError,
        {data: SaveOrderBody},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof saveOrder>>,
    TError,
    {data: SaveOrderBody},
    TContext
> => {
    const mutationOptions = getSaveOrderMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Deprecated. Use PUT /api/rest/optimaxcheckout/v2/{quoteType}/cart/shipping
 * @deprecated
 * @summary Shipping method save action
 */
export const putQuoteShipping = (putQuoteShippingBody: PutQuoteShippingBody) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append('shipping_method', putQuoteShippingBody.shipping_method);

    return fetcherMagento<void>({
        url: `/glassescheckout/onepage_sdk/saveShippingMethod`,
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        data: formUrlEncoded,
    });
};

export const getPutQuoteShippingMutationOptions = <
    TError = AjaxErrorResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteShipping>>,
        TError,
        {data: PutQuoteShippingBody},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof putQuoteShipping>>,
    TError,
    {data: PutQuoteShippingBody},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putQuoteShipping>>,
        {data: PutQuoteShippingBody}
    > = props => {
        const {data} = props ?? {};

        return putQuoteShipping(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type PutQuoteShippingMutationResult = NonNullable<
    Awaited<ReturnType<typeof putQuoteShipping>>
>;
export type PutQuoteShippingMutationBody = PutQuoteShippingBody;
export type PutQuoteShippingMutationError = AjaxErrorResponse;

/**
 * @deprecated
 * @summary Shipping method save action
 */
export const usePutQuoteShipping = <TError = AjaxErrorResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putQuoteShipping>>,
        TError,
        {data: PutQuoteShippingBody},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof putQuoteShipping>>,
    TError,
    {data: PutQuoteShippingBody},
    TContext
> => {
    const mutationOptions = getPutQuoteShippingMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * Deprecated. Use GET /api/rest/optimaxcheckout/v2/{quoteType}/cart/shippings
 * @deprecated
 * @summary Get allowed shipping methods for current shopping cart
 */
export const getAllowedShippingMethods = (
    params: GetAllowedShippingMethodsParams,
    signal?: AbortSignal,
) => {
    return fetcherMagento<ShippingMethodList>({
        url: `/optimaxcheckout/shipping`,
        method: 'GET',
        params,
        signal,
    });
};

export const getGetAllowedShippingMethodsQueryKey = (params: GetAllowedShippingMethodsParams) => {
    return [`/optimaxcheckout/shipping`, ...(params ? [params] : [])] as const;
};

export const getGetAllowedShippingMethodsQueryOptions = <
    TData = Awaited<ReturnType<typeof getAllowedShippingMethods>>,
    TError = AjaxErrorResponse,
>(
    params: GetAllowedShippingMethodsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getAllowedShippingMethods>>, TError, TData>
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllowedShippingMethodsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowedShippingMethods>>> = ({
        signal,
    }) => getAllowedShippingMethods(params, signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof getAllowedShippingMethods>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetAllowedShippingMethodsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAllowedShippingMethods>>
>;
export type GetAllowedShippingMethodsQueryError = AjaxErrorResponse;

/**
 * @deprecated
 * @summary Get allowed shipping methods for current shopping cart
 */
export const useGetAllowedShippingMethods = <
    TData = Awaited<ReturnType<typeof getAllowedShippingMethods>>,
    TError = AjaxErrorResponse,
>(
    params: GetAllowedShippingMethodsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getAllowedShippingMethods>>, TError, TData>
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetAllowedShippingMethodsQueryOptions(params, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getGetAllowedShippingMethodsSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getAllowedShippingMethods>>,
    TError = AjaxErrorResponse,
>(
    params: GetAllowedShippingMethodsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAllowedShippingMethods>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getGetAllowedShippingMethodsQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllowedShippingMethods>>> = ({
        signal,
    }) => getAllowedShippingMethods(params, signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getAllowedShippingMethods>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type GetAllowedShippingMethodsSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getAllowedShippingMethods>>
>;
export type GetAllowedShippingMethodsSuspenseQueryError = AjaxErrorResponse;

/**
 * @deprecated
 * @summary Get allowed shipping methods for current shopping cart
 */
export const useGetAllowedShippingMethodsSuspense = <
    TData = Awaited<ReturnType<typeof getAllowedShippingMethods>>,
    TError = AjaxErrorResponse,
>(
    params: GetAllowedShippingMethodsParams,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getAllowedShippingMethods>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getGetAllowedShippingMethodsSuspenseQueryOptions(params, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};
